var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueDropzone',{ref:"vueDz",attrs:{"id":"dropzone","options":_vm.vdzOptions},on:{"vdropzone-sending":_vm.sendingEvent,"vdropzone-success":_vm.successEvent,"vdropzone-error":_vm.errorEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }